import { axios } from '@/utils/request'
  
export function subjectForGroupOptions(parameter) {
    return axios({
        url: '/adminapi/vsscore/subjectForGroupOptions',
        method: 'get',
        params: parameter
    })
}
export function groupList(parameter) {
    return axios({
        url: '/adminapi/vsscore/groupList',
        method: 'get',
        params: parameter
    })
}
 
export function groupAdd(parameter) {
    return axios({
        url: '/adminapi/vsscore/groupAdd',
        method: 'post',
        data: parameter
    })
}

export function groupEdit(parameter) {
    return axios({
        url: '/adminapi/vsscore/groupEdit',
        method: 'post',
        data: parameter
    })
}

export function groupDelete(parameter) {
    return axios({
        url: '/adminapi/vsscore/groupDelete',
        method: 'post',
        data: parameter
    })
}

export function createGroupMatch(parameter) {
    return axios({
        url: '/adminapi/vsscore/createGroupMatch',
        method: 'post',
        data: parameter
    })
}



export function setGroupItem(parameter) {
    return axios({
        url: '/adminapi/vsscore/setGroupItem',
        method: 'post',
        data: parameter
    })
}

export function setTreeNode(parameter) {
    return axios({
        url: '/adminapi/vsscore/setTreeNode',
        method: 'post',
        data: parameter
    })
}

export function vsTree(parameter) {
    return axios({
        url: '/adminapi/vsscore/vsTree',
        method: 'get',
        params: parameter
    })
}
 


export function placeAdd(parameter) {
    return axios({
        url: '/adminapi/vsscore/placeAdd',
        method: 'post',
        data: parameter
    })
}

export function placeEdit(parameter) {
    return axios({
        url: '/adminapi/vsscore/placeEdit',
        method: 'post',
        data: parameter
    })
}

export function placeDelete(parameter) {
    return axios({
        url: '/adminapi/vsscore/placeDelete',
        method: 'post',
        data: parameter
    })
}


export function placeList(parameter) {
    return axios({
        url: '/adminapi/vsscore/placeList',
        method: 'get',
        params: parameter
    })
}
 

export function placeDetail(parameter) {
    return axios({
        url: '/adminapi/vsscore/placeDetail',
        method: 'get',
        params: parameter
    })
}
 

export function matchList(parameter) {
    return axios({
        url: '/adminapi/vsscore/matchList',
        method: 'get',
        params: parameter
    })
}
 

export function matchDetail(parameter) {
    return axios({
        url: '/adminapi/vsscore/matchDetail',
        method: 'get',
        params: parameter
    })
}
 

export function placeOptions(parameter) {
    return axios({
        url: '/adminapi/vsscore/placeOptions',
        method: 'get',
        params: parameter
    })
}
 


export function matchEdit(parameter) {
    return axios({
        url: '/adminapi/vsscore/matchEdit',
        method: 'post',
        data: parameter
    })
}

export function setMatchStatus(parameter) {
    return axios({
        url: '/adminapi/vsscore/setMatchStatus',
        method: 'post',
        data: parameter
    })
}

export function createVsTree(parameter) {
    return axios({
        url: '/adminapi/vsscore/createVsTree',
        method: 'post',
        data: parameter
    })
}